import {
  FaArrowUp,
  FaBan,
  FaCheck,
  FaCog,
  FaCopy,
  FaKey,
  FaUserSlash,
} from "react-icons/fa";
import ContentContainer from "../components/ContentContainer";
import { useExaminer } from "../hooks/useExaminer";
import { useIsMobile } from "../hooks/useIsMobile";
import ExaminerManager from "../components/ExaminerManager";

export default function ExaminerPage() {
  const isMobile = useIsMobile();
  const {
    examiner,
    formData,
    isDisabled,
    handleChange,
    onSubmit,
    handleSettingsToggle,
    handleCopy,
    handleCredentials,
    handleDeleteExaminer,
    groups,
  } = useExaminer();

  return (
    <>
      {examiner == null && (
        <ContentContainer>
          <div className={`pl-5 pt-[10vh] ${isMobile ? "" : "hidden"}`}>
            <FaArrowUp aria-hidden="true" />
            <h1 className="text-black text-xl">Selectionnez un examinateur</h1>
          </div>
        </ContentContainer>
      )}
      {examiner && (
        <ContentContainer>
          <div className=" h-full flex justify-center items-center">
            <div className="grid grid-cols-4 gap-4  gap-y-8 w-full max-sm:pb-2">
              <LabelInput
                label="Nom"
                value={formData.surname}
                disabled={isDisabled}
                onChange={(value) => handleChange("surname", value)}
              />
              {!isDisabled && (
                <IconButton4
                  altText={"valider"}
                  icon={
                    <FaCheck className="justify-self-center" color="green" />
                  }
                  onClick={onSubmit}
                />
              )}

              <LabelInput
                label="Prénom"
                value={formData.name}
                disabled={isDisabled}
                onChange={(value) => handleChange("name", value)}
              />
              <IconButton4
                altText={"modifier les inforamtions"}
                icon={<FaCog className="justify-self-center" />}
                onClick={handleSettingsToggle}
              />

              <LabelInput
                label="Identifiant"
                value={formData.username}
                disabled
                onChange={() => {}}
              />
              <IconButton3
                altText={"Copier le nom d'utilisateur"}
                icon={<FaCopy className="justify-self-center " />}
                onClick={() => handleCopy(formData.username)}
              />

              <IconButton4
                icon={<FaKey className="justify-self-center" />}
                altText="Générer mot de passe"
                onClick={() => handleCredentials("generate")}
              />

              <LabelInput
                label="Mot de Passe"
                value={formData.password}
                disabled
                onChange={() => {}}
              />
              <IconButton3
                altText={"Copier le mot de passer"}
                icon={<FaCopy className="justify-self-center" />}
                onClick={() => handleCopy(formData.password)}
              />
              <IconButton4
                icon={<FaBan className="justify-self-center" />}
                altText="Supprimer identifiants"
                onClick={() => handleCredentials("delete")}
              />

              <IconButton4
                icon={<FaUserSlash className="justify-self-center" />}
                altText="Supprimer Examinateur"
                onClick={() => handleDeleteExaminer()}
              />
            </div>
          </div>
          {examiner !== -1 && (
            <ExaminerManager examinerId={examiner.id} groups={groups} />
          )}
        </ContentContainer>
      )}
    </>
  );
}

const LabelInput = ({ label, value, disabled, onChange, id }) => (
  <>
    <label
      htmlFor={id}
      className="col-start-1 place-self-end max-sm:place-self-center sm:text-base text-sm h-7"
    >
      {label}
    </label>
    <input
      id={id}
      type="text"
      disabled={disabled}
      placeholder={label}
      value={value}
      className="border border-black px-1 max-sm:w-[10rem] h-10"
      onChange={(e) => onChange(e.target.value)}
    />
  </>
);

const IconButton4 = ({ icon, altText, onClick }) => (
  <button
    type="button"
    className={`w-7 h-7 col-start-4 max-sm:place-self-end  p-1 m-1 rounded hover:bg-black hover:text-white`}
    aria-label={altText}
    onClick={onClick}
  >
    {icon}
  </button>
);

const IconButton3 = ({ icon, altText, onClick }) => (
  <button
    type="button"
    className={`w-7 h-7 col-start-3  max-sm:place-self-end m-1 rounded hover:bg-black hover:text-white`}
    aria-label={altText}
    onClick={onClick}
  >
    {icon}
  </button>
);
